import type { FC, SVGProps } from 'react';

type BinocularIconProps = SVGProps<SVGSVGElement>;

/** SVG-иконка бинокля */
export const BinocularIcon: FC<BinocularIconProps> = ({ className, ...props }) => (
  <svg
    className={className}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <circle cx="256" cy="256" r="252.5" fill="var(--icon-binocular-surface)" />
    <path fill="var(--icon-binocular-primary)" d="M210.4 212.1h91.3v47.5h-91.3z" />
    <path
      fill="var(--icon-binocular-body)"
      d="M186.2 136.3c-28.5-5.2-56.7 10.5-67.2 37.5l-39.2 95.7L234 297.4l1.9-99.8c.9-29.9-20.2-56-49.7-61.3z"
    />
    <circle cx="154.4" cy="297.1" r="79.6" fill="var(--icon-binocular-primary)" />
    <path
      fill="var(--icon-binocular-lens)"
      d="M144.6 351.4c-29.9-5.4-49.8-34.2-44.4-64.1 5.4-29.9 34.2-49.8 64.1-44.4 29.9 5.4 49.8 34.2 44.4 64.1-5.5 29.9-34.2 49.8-64.1 44.4z"
    />
    <path
      fill="var(--icon-binocular-body)"
      d="M325.8 136.3c28.5-5.2 56.7 10.5 67.2 37.5l39.2 95.7L278 297.4l-1.9-99.8c-.9-29.9 20.2-56 49.7-61.3z"
    />
    <circle cx="357.6" cy="297.1" r="79.6" fill="var(--icon-binocular-primary)" />
    <path
      fill="var(--icon-binocular-lens)"
      d="M367.4 351.4c29.9-5.4 49.8-34.2 44.4-64.1s-34.2-49.8-64.1-44.4c-29.9 5.4-49.8 34.2-44.4 64.1 5.5 29.9 34.2 49.8 64.1 44.4zm-222.8 0c-29.9-5.4-49.8-34.2-44.4-64.1 5.4-29.9 34.2-49.8 64.1-44.4 29.9 5.4 49.8 34.2 44.4 64.1-5.5 29.9-34.2 49.8-64.1 44.4z"
    />
    <ellipse
      cx="340.6"
      cy="285.1"
      fill="var(--icon-binocular-highlight)"
      rx="13.1"
      ry="21.6"
      transform="rotate(38.565 340.635 285.058)"
    />
    <ellipse
      cx="133.4"
      cy="285.1"
      fill="var(--icon-binocular-highlight)"
      rx="13.1"
      ry="21.6"
      transform="rotate(38.565 133.368 285.064)"
    />
  </svg>
);
